import { Button, Flex, Modal, Small } from "orcs-design-system";

import { getDesignOptionLabel } from "./designOptionLabels";

type DesignOption = {
  id: string;
  name: string;
  isTrunk: boolean;
};

type ConfirmOptionActionModalProps = {
  visible: boolean;
  option: DesignOption | null;
  baselineDataDate?: string | null;
  frozen?: boolean;
  onClose: () => void;
  onConfirm: (option: DesignOption) => Promise<void> | void;
};

const ConfirmOptionActionModal = ({
  visible,
  option,
  baselineDataDate = null,
  frozen = false,
  onClose,
  onConfirm,
}: ConfirmOptionActionModalProps) => {
  const label = option
    ? getDesignOptionLabel(option, baselineDataDate)
    : "this option";

  return (
    <Modal
      visible={visible}
      onClose={onClose}
      headerContent="Delete option"
      footerContent={
        <Flex justifyContent="flex-end" gap="s">
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={frozen}
            onClick={async () => {
              if (!option) return;
              await onConfirm(option);
              onClose();
            }}
          >
            Delete option
          </Button>
        </Flex>
      }
    >
      <Small>
        {`Remove ${label}? Overlay edits for this option are discarded. The live tree is unchanged.`}
      </Small>
    </Modal>
  );
};

export default ConfirmOptionActionModal;
